export default {
  path: '/echoes',
  name: 'echoes',
  meta: { title: '圆桌智囊团' },
  children: [
    {
      path: '/echoes/index',
      name: 'echoesIndex',
      component: () => import('@/views/echoes/index.vue'),
      meta: { title: '圆桌智囊团', subTitle: '深度思维碰撞，跨越时空的顶尖头脑风暴', key: 'echoes' },
    },
  ],
};
